import { VehicleDto, VehicleFullReferenceDto, VehicleReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type VehicleDtoAny = VehicleDto | VehicleReferenceDto | VehicleFullReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type VehicleDtoAll = VehicleDto & VehicleReferenceDto & VehicleFullReferenceDto;

export class VehicleMapper {}
